/**
 * Customer.io inline in-app message "Position IDs".
 *
 * Each value is the `id` of an empty DOM element that a Customer.io inline
 * in-app campaign targets (the "Position" field when building the message).
 * Customer.io replaces the element's contents with the campaign creative when a
 * campaign is active, and leaves it empty (collapsed) otherwise.
 *
 * These are plain string constants (no SDK import) so both the analytics module
 * and the anchor components can reference them without pulling in the CDP
 * package. Keep them in sync with the campaign configuration in Customer.io.
 */
export const CUSTOMERIO_POSITIONS = {
  // 328x72 payment banner shown below the installment options.
  installmentsList: "cio-payoptions-installments-list",
} as const;

export type CustomerioPosition = (typeof CUSTOMERIO_POSITIONS)[keyof typeof CUSTOMERIO_POSITIONS];
